import { PLACEHOLDER_MESSAGES } from '@/utilities/constants/placeholder';
import MainLoader from '@/features/LoadingScreen/anexes/MainLoader';
import { PokerSuitsAnimation } from '@/features/LoadingScreen/components/PokerSuitsAnimation';
import { useLoadingErrorPopup } from '@/features/LoadingScreen/useLoadingErrorPopup';
import {
  POKER_LOADING_GRADIENT,
  POKER_SUIT_ANIMATION_SIZE,
} from '@/features/LoadingScreen/constants/constants';
import { LocationNote } from '@/geolocation/screens/GeolocationHelperNotes';

import './components/styles/PokerLoadingScreen.scss';

export type PokerLoadingScreenProps = {
  type: string;
  isStuckedLoading: boolean;
  onAnimationFinish?: () => void;
};

export const PokerLoadingScreen = ({
  type,
  isStuckedLoading,
  onAnimationFinish,
}: PokerLoadingScreenProps) => {
  useLoadingErrorPopup(type);

  return (
    <div
      className="poker-loading-screen"
      id="default-loader-container"
      style={{
        background: POKER_LOADING_GRADIENT,
        ['--icon-size' as string]: POKER_SUIT_ANIMATION_SIZE,
      }}
    >
      <div id="logo-container" className="poker-loading-screen__animation">
        <PokerSuitsAnimation />
      </div>
      <MainLoader
        type={type}
        isStuckedLoading={isStuckedLoading}
        onAnimationFinish={onAnimationFinish}
      />
      <p
        key={type}
        className={`poker-loading-screen__text ${type}`}
        data-testid="loading-screen-text"
      >
        {PLACEHOLDER_MESSAGES[type]}
      </p>
      <div className="poker-loading-screen__status-slot">
        <LocationNote />
      </div>
    </div>
  );
};
